document.addEventListener("DOMContentLoaded", function () {

  new Swiper(".testimonial-slider", {

    loop: true,

    speed: 800,

    spaceBetween: 30,

    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },

    breakpoints: {

      0: {
        slidesPerView: 1
      },

      768: {
        slidesPerView: 2
      },

      990: {
        slidesPerView: 3
      }

    }

  });

});